import React, { useEffect, useState } from 'react';
import { PivotBasicTab } from 'components';
import moveIcon from 'images/SVG/group-2.svg';
import {

	mergeStyleSets,

} from 'office-ui-fabric-react';
// import PhoenixDynamicFields from '../components/PhoenixDynamicFields';
import { childNodesCheckbox, childNodesExpand } from '../../outPut/OutPutAction';
import { useDispatch, useSelector } from 'react-redux';
import { selectDimension, updateXDEDimensions, updateXDEDimensionsOrder } from '../redux/PhoenixActions';


const styles = mergeStyleSets({
	root: [
		{
			selectors: {
				'::before': {
					background: '#ccc',
				},
			},
		},
	],
	fileIconCell: {
		textAlign: 'center',
		width: '28px',
		selectors: {
			'&:before': {
				content: '.',
				display: 'inline-block',
				verticalAlign: 'middle',
				height: '100%',
				width: '28px',
				visibility: 'hidden',
			},
		},
	},
	fileIconImg: {
		verticalAlign: 'middle',
		maxHeight: '16px',
		maxWidth: '16px',
	},
});

const outputColumns = [
	{
		key: 'column1',
		name: 'moveIcon',
		className: styles.fileIconCell,
		iconClassName: styles.fileIconImg,
		ariaLabel: 'Move Icon',
		iconName: 'Move',
		isIconOnly: true,
		fieldName: 'moveIcon',
		minWidth: 16,
		maxWidth: 16,
		iconPath: { moveIcon },
	},
	{
		key: 'column2',
		name: 'Name',
		fieldName: 'colText',
	},
];

const DimensionsConfigurationStep = () => {
	const dispatch = useDispatch();
	const dimensions = useSelector(state => state.data.phoenixReducers.dimensions.xdeDimensions);
	const arrangeFields = useSelector(state => state.data.phoenixReducers.dimensions.xdeDimensionOrder);

	const onExpandClick = event => {
		const colId = event.target.id.split('-');
		const nodes = [...dimensions];
		// childNodesExpand(nodes, colId);
		dispatch(updateXDEDimensions({data:nodes,colId:colId}))
	};


	const onSelect = (event) => {
		const dims = [...dimensions];
		// childNodesCheckbox(dims, event.target.checked, event.target.id);
		dispatch(selectDimension({data : event.target.id, checked : event.target.checked}))
	}

	const handleDimensionOrderChange = (arrangeFields) => {
		dispatch(updateXDEDimensionsOrder({data:arrangeFields}));
	}

	return (
		<div className="ms-Grid out-put-container " dir="ltr">
			<PivotBasicTab
				fields={dimensions}
				columns={outputColumns}
				arrangeFields={arrangeFields}
				onSelect={onSelect}
				handleDragDropEvents={handleDimensionOrderChange}
				isArrangeField={true}
				onLinkClick={() => console.log('output node selected: ')}
				onExpandClick={onExpandClick}
			/>
		</div>
	);
};

export default DimensionsConfigurationStep;
